export default __webpack_public_path__ + "static/media/capitaGreen.jpg?.976f7b71";